import type { SupabaseClient } from '@supabase/supabase-js';

function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = '='.repeat((4 - base64.length % 4) % 4);
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}

export async function maybeShowPushBanner(supabase: SupabaseClient) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
  if (Notification.permission === 'granted' || Notification.permission === 'denied') return;

  const dismissed = localStorage.getItem('push_banner_dismissed_at');
  if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

  if (document.getElementById('push-banner')) return;

  const banner = document.createElement('div');
  banner.id = 'push-banner';
  banner.innerHTML = `
    <style>
      #push-banner { position: fixed; bottom: 16px; left: 16px; right: 16px; max-width: 480px;
        margin: 0 auto; background: white; border-radius: 12px; padding: 16px; z-index: 50;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
      #push-banner button { display: inline-block; width: auto; padding: 8px 16px;
        margin-right: 8px; }
    </style>
    <div style="font-weight: 600; margin-bottom: 8px;">🔔 Get cycle notifications?</div>
    <p style="color: #6b7280; font-size: 14px; margin-bottom: 12px;">
      We'll let you know when your cycle is finishing.
    </p>
    <button id="push-yes" class="primary">Send me notifications</button>
    <button id="push-no" class="secondary">Not now</button>
  `;
  document.body.appendChild(banner);

  document.getElementById('push-yes')!.addEventListener('click', async () => {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') { banner.remove(); return; }

    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY),
      });

      const { data: { session } } = await supabase.auth.getSession();
      const subJson = sub.toJSON();
      await fetch('/api/push/subscribe', {
        method: 'POST',
        headers: { Authorization: `Bearer ${session!.access_token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          endpoint: sub.endpoint,
          keys: subJson.keys,
          user_agent: navigator.userAgent,
        }),
      });
    } catch (e) {
      console.error('push subscribe failed', e);
    }
    banner.remove();
  });

  document.getElementById('push-no')!.addEventListener('click', () => {
    localStorage.setItem('push_banner_dismissed_at', String(Date.now()));
    banner.remove();
  });
}
